import React, { useState, useEffect } from "react";
import BotonManualHeader from "../../components/BotonManualHeader";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Table,
  Badge,
  Modal,
  Spinner,
  Alert,
  Tabs,
  Tab,
  InputGroup,
  ListGroup,
  Accordion,
} from "react-bootstrap";
import {
  FaMapMarkerAlt,
  FaEdit,
  FaHistory,
  FaCheck,
  FaTimes,
  FaClock,
  FaSearch,
  FaUserClock,
  FaIdCard,
  FaExclamationTriangle,
  FaInfoCircle,
  FaUser,
  FaBuilding,
  FaPlusCircle,
  FaUsers,
  FaUserCheck,
  FaSync,
  FaCogs,
  FaTrash,
} from "react-icons/fa";
import firebaseApp from "../../firebase/credenciales";
import { asignarSedeAUsuario } from "../../services/coordenadasSedeService";
import {
  getFirestore,
  collection,
  doc,
  setDoc,
  updateDoc,
  query,
  where,
  getDocs,
  addDoc,
  serverTimestamp,
  orderBy,
  limit,
  getDoc,
  deleteDoc,
} from "firebase/firestore";

const db = getFirestore(firebaseApp);

// Componente principal
const AsistenciaCoordenadas = ({ usuario }) => {
  // Estado para búsqueda de trabajador
  const [dni, setDni] = useState("");
  const [buscando, setBuscando] = useState(false);
  const [datosUsuario, setDatosUsuario] = useState(null);
  const [error, setError] = useState("");
  const [mensaje, setMensaje] = useState("");

  // Estado para sedes de la empresa
  const [sedesEmpresa, setSedesEmpresa] = useState([]);
  const [cargandoSedes, setCargandoSedes] = useState(false);
  const [modalSedeEmpresaVisible, setModalSedeEmpresaVisible] = useState(false);
  const [sedeEmpresaActual, setSedeEmpresaActual] = useState(null);
  const [regimenesTrabajo, setRegimenesTrabajo] = useState([]);
  const [regimenSeleccionado, setRegimenSeleccionado] = useState("");
  const [cargandoSedeEmpresa, setCargandoSedeEmpresa] = useState(false);

  // Estado para empresas y coordenadas
  const [empresas, setEmpresas] = useState([]);
  const [coordenadas, setCoordenadas] = useState([]);
  const [filtroEmpresa, setFiltroEmpresa] = useState("");
  const [filtroActivo, setFiltroActivo] = useState(true);
  const [cargando, setCargando] = useState(false);

  // Estado para el formulario
  const [modalVisible, setModalVisible] = useState(false);
  const [modoEdicion, setModoEdicion] = useState(false);
  const [coordenadaActual, setCoordenadaActual] = useState(null);

  // Estado para modal de sedes
  const [modalSedesVisible, setModalSedesVisible] = useState(false);
  const [sedeSeleccionada, setSedeSeleccionada] = useState(null);

  // Estado para campos del formulario
  const [nombreSede, setNombreSede] = useState("");
  const [latitud, setLatitud] = useState(0);
  const [longitud, setLongitud] = useState(0);
  const [radio, setRadio] = useState(100);
  const [nombreEmpresa, setNombreEmpresa] = useState("");
  const [idEmpresa, setIdEmpresa] = useState("");
  const [prioridad, setPrioridad] = useState(1);
  const [activo, setActivo] = useState(true);
  const [idSede, setIdSede] = useState("");
  const [motivoCambio, setMotivoCambio] = useState("");

  // Campos opcionales para horarios
  const [horarioIngreso, setHorarioIngreso] = useState("");
  const [horarioSalida, setHorarioSalida] = useState("");
  const [inicioRefrigerio, setInicioRefrigerio] = useState("");
  const [finRefrigerio, setFinRefrigerio] = useState("");
  const [incluyeHorario, setIncluyeHorario] = useState(false);

  // Estado para mostrar historial
  const [historialVisible, setHistorialVisible] = useState(false);
  const [historialCoordenada, setHistorialCoordenada] = useState([]);

  // Estados para asignación masiva
  const [modalAsignacionMasiva, setModalAsignacionMasiva] = useState(false);
  const [sedeParaAsignar, setSedeParaAsignar] = useState(null);
  const [usuariosDisponibles, setUsuariosDisponibles] = useState([]);
  const [usuariosSeleccionados, setUsuariosSeleccionados] = useState([]);
  const [cargandoUsuarios, setCargandoUsuarios] = useState(false);
  const [asignandoMasivo, setAsignandoMasivo] = useState(false);
  const [filtroUsuarios, setFiltroUsuarios] = useState("");
  const [usuariosAsignados, setUsuariosAsignados] = useState({});

  // Estados para grupos
  const [gruposEmpresa, setGruposEmpresa] = useState([]);
  const [cargandoGrupos, setCargandoGrupos] = useState(false);
  const [modalAsignacionGrupos, setModalAsignacionGrupos] = useState(false);
  const [gruposSeleccionados, setGruposSeleccionados] = useState([]);
  const [asignandoGrupos, setAsignandoGrupos] = useState(false);
  const [filtroGrupos, setFiltroGrupos] = useState("");
  const [modoAsignacion, setModoAsignacion] = useState("individual");

  // NUEVOS ESTADOS para selección múltiple y eliminación
  const [usuariosSeleccionadosParaEliminar, setUsuariosSeleccionadosParaEliminar] = useState({});
  const [eliminandoMasivo, setEliminandoMasivo] = useState(false);
  const [modoSeleccionMultiple, setModoSeleccionMultiple] = useState({});

  // Estados para modales personalizados
  const [modalConfirmacion, setModalConfirmacion] = useState(false);
  const [modalPrompt, setModalPrompt] = useState(false);
  const [mensajeConfirmacion, setMensajeConfirmacion] = useState("");
  const [mensajePrompt, setMensajePrompt] = useState("");
  const [valorPrompt, setValorPrompt] = useState("");
  const [callbackConfirmacion, setCallbackConfirmacion] = useState(null);
  const [callbackPrompt, setCallbackPrompt] = useState(null);

  // Funciones auxiliares para modales personalizados
  const mostrarConfirmacion = (mensaje, callback) => {
    setMensajeConfirmacion(mensaje);
    setCallbackConfirmacion(() => callback);
    setModalConfirmacion(true);
  };

  const mostrarPrompt = (mensaje, callback) => {
    setMensajePrompt(mensaje);
    setValorPrompt("");
    setCallbackPrompt(() => callback);
    setModalPrompt(true);
  };

  const confirmarAccion = () => {
    if (callbackConfirmacion) {
      callbackConfirmacion(true);
    }
    setModalConfirmacion(false);
    setCallbackConfirmacion(null);
  };

  const cancelarAccion = () => {
    if (callbackConfirmacion) {
      callbackConfirmacion(false);
    }
    setModalConfirmacion(false);
    setCallbackConfirmacion(null);
  };

  const confirmarPrompt = () => {
    if (callbackPrompt) {
      callbackPrompt(valorPrompt);
    }
    setModalPrompt(false);
    setCallbackPrompt(null);
    setValorPrompt("");
  };

  const cancelarPrompt = () => {
    if (callbackPrompt) {
      callbackPrompt(null);
    }
    setModalPrompt(false);
    setCallbackPrompt(null);
    setValorPrompt("");
  };

  // Cargar datos iniciales
  useEffect(() => {
    cargarEmpresas();
    if (usuario && usuario.ruc) {
      cargarSedesEmpresa(usuario.ruc);
    }
  }, [usuario]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (datosUsuario && datosUsuario.dni) {
        cargarCoordenadas();
      }
    }, 300);

    return () => clearTimeout(timer);
  }, [filtroEmpresa, filtroActivo, datosUsuario?.dni]);

  useEffect(() => {
    if (modalSedeEmpresaVisible) {
      if (sedeEmpresaActual) {
        setNombreSede(sedeEmpresaActual.nombre || "");
        setLatitud(sedeEmpresaActual.latitud || 0);
        setLongitud(sedeEmpresaActual.longitud || 0);
        setRadio(sedeEmpresaActual.radio || 100);
        setActivo(sedeEmpresaActual.activo !== false);
        setHorarioIngreso(sedeEmpresaActual.horarioIngreso || "");
        setHorarioSalida(sedeEmpresaActual.horarioSalida || "");
        setInicioRefrigerio(sedeEmpresaActual.inicioRefrigerio || "");
        setFinRefrigerio(sedeEmpresaActual.finRefrigerio || "");
        setRegimenSeleccionado(
          sedeEmpresaActual.regimenId ? String(sedeEmpresaActual.regimenId) : ""
        );
      } else {
        setNombreSede("");
        setLatitud(0);
        setLongitud(0);
        setRadio(100);
        setActivo(true);
        setHorarioIngreso("");
        setHorarioSalida("");
        setInicioRefrigerio("");
        setFinRefrigerio("");
        setRegimenSeleccionado("");
      }
    }
  }, [modalSedeEmpresaVisible, sedeEmpresaActual]);

  useEffect(() => {
    const cargarRegimenes = async () => {
      if (!usuario?.ruc) return;
      const regimenesRef = collection(db, "pl_regimen_trabajo");
      const q = query(regimenesRef, where("ruc", "==", usuario.ruc));
      const snapshot = await getDocs(q);
      const lista = [];
      snapshot.forEach(doc => {
        lista.push({ id: doc.id, ...doc.data() });
      });
      setRegimenesTrabajo(lista);
    };
    if (modalSedeEmpresaVisible) {
      cargarRegimenes();
    }
  }, [modalSedeEmpresaVisible, usuario]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (usuario?.ruc) {
        cargarUsuariosAsignados();
      }
    }, 500);

    return () => clearTimeout(timer);
  }, [usuario?.ruc]);

  // ======================== FUNCIONES PRINCIPALES ========================

  // Función para cargar empresas
  const cargarEmpresas = async () => {
    try {
      const listaEmpresas = [];

      if (usuario && usuario.ruc) {
        const empresaRef = doc(db, "company", usuario.ruc);
        const empresaSnap = await getDoc(empresaRef);

        if (empresaSnap.exists()) {
          const empresa = empresaSnap.data();
          listaEmpresas.push({
            id: usuario.ruc,
            nombre: empresa.name || "Mi Empresa",
            ruc: usuario.ruc,
          });
          setIdEmpresa(usuario.ruc);
          setNombreEmpresa(empresa.name || "Mi Empresa");
        } else {
          listaEmpresas.push({
            id: usuario.ruc,
            nombre: usuario.empresa || "Mi Empresa",
            ruc: usuario.ruc,
          });
          setIdEmpresa(usuario.ruc);
          setNombreEmpresa(usuario.empresa || "Mi Empresa");
        }
      }

      setEmpresas(listaEmpresas);
    } catch (error) {
      console.error("Error al cargar empresas:", error);
      setError("No se pudieron cargar los datos de la empresa. Intente nuevamente.");
    }
  };

  // Función para cargar sedes de la empresa
  const cargarSedesEmpresa = async (ruc) => {
    if (!ruc) return;

    setCargandoSedes(true);
    setError("");

    try {
      const sedesRef = collection(db, `company_cordenadas/${ruc}/sedes`);
      const sedesQuery = query(sedesRef, orderBy("nombre"));
      const snapshot = await getDocs(sedesQuery);
      const listaSedes = [];

      snapshot.forEach((doc) => {
        const sede = doc.data();
        listaSedes.push({
          id: doc.id,
          nombre: sede.nombre || "Sede sin nombre",
          latitud: sede.latitud,
          longitud: sede.longitud,
          radio: sede.radio || 100,
          activo: sede.activo !== undefined ? sede.activo : true,
          createdAt: sede.createdAt,
          updatedAt: sede.updatedAt,
          horarioIngreso: sede.horarioIngreso,
          horarioSalida: sede.horarioSalida,
          inicioRefrigerio: sede.inicioRefrigerio,
          finRefrigerio: sede.finRefrigerio,
          regimenId: sede.regimenId || "",
          regimenNombre: sede.regimenNombre || "",
        });
      });

      setSedesEmpresa(listaSedes);
      setMensaje(`Se cargaron ${listaSedes.length} sedes de la empresa`);
    } catch (error) {
      console.error("Error al cargar sedes de la empresa:", error);
      setError("No se pudieron cargar las sedes de la empresa. Intente nuevamente.");
    } finally {
      setCargandoSedes(false);
    }
  };

  // Función para cargar grupos de la empresa
  const cargarGruposEmpresa = async () => {
    if (!usuario?.ruc) return;

    setCargandoGrupos(true);
    try {
      const gruposRef = collection(db, `grupos/${usuario.ruc}/grupos`);
      const gruposQuery = query(gruposRef, orderBy("name"));
      const snapshot = await getDocs(gruposQuery);
      const listaGrupos = [];

      snapshot.forEach((doc) => {
        const grupo = doc.data();
        listaGrupos.push({
          id: doc.id,
          name: grupo.name || "Grupo sin nombre",
          description: grupo.description || "",
          members: grupo.members || [],
          rucEmpresa: grupo.rucEmpresa,
          createdAt: grupo.createdAt,
          updatedAt: grupo.updatedAt,
        });
      });

      setGruposEmpresa(listaGrupos);
      console.log(`✅ Cargados ${listaGrupos.length} grupos de la empresa`);
    } catch (error) {
      console.error("Error al cargar grupos:", error);
      setError("Error al cargar grupos de la empresa");
    } finally {
      setCargandoGrupos(false);
    }
  };

  // Función para cargar coordenadas
  const cargarCoordenadas = async () => {
    if (!datosUsuario || !datosUsuario.dni) return;

    setCargando(true);
    setError("");

    try {
      const dniTrabajador = datosUsuario.dni;
      const coordenadasRef = collection(db, `asistencia/${dniTrabajador}/coordenadas`);

      let queryConstraints = [];

      if (filtroActivo !== null) {
        queryConstraints.push(where("activo", "==", filtroActivo));
      }

      if (filtroEmpresa) {
        queryConstraints.push(where("id_empresa", "==", filtroEmpresa));
      }

      queryConstraints.push(orderBy("prioridad"));

      const coordenadasQuery = query(coordenadasRef, ...queryConstraints);
      const snapshot = await getDocs(coordenadasQuery);

      const coordenadasFiltradas = [];

      snapshot.forEach((doc) => {
        const coordenadaData = doc.data();
        coordenadasFiltradas.push({
          id: doc.id,
          dni: dniTrabajador,
          nombreTrabajador: `${datosUsuario.name || ""} ${datosUsuario.apellidos || ""}`,
          latitud: coordenadaData.latitud,
          longitud: coordenadaData.longitud,
          radio: coordenadaData.radio,
          nombre: coordenadaData.nombre,
          empresa: coordenadaData.empresa,
          id_empresa: coordenadaData.id_empresa,
          prioridad: coordenadaData.prioridad,
          activo: coordenadaData.activo,
          ultimoUso: coordenadaData.ultimoUso,
          createdAt: coordenadaData.createdAt,
          horarioIngreso: coordenadaData.horarioIngreso,
          horarioSalida: coordenadaData.horarioSalida,
          inicioRefrigerio: coordenadaData.inicioRefrigerio,
          finRefrigerio: coordenadaData.finRefrigerio,
          grupoNombre: coordenadaData.grupoNombre,
          grupoId: coordenadaData.grupoId,
          asignadoPorGrupo: coordenadaData.asignadoPorGrupo || false,
        });
      });

      setCoordenadas(coordenadasFiltradas);
      console.log(`✅ Cargadas ${coordenadasFiltradas.length} coordenadas para ${dniTrabajador}`);

    } catch (error) {
      console.error("Error al cargar coordenadas:", error);

      if (error.code === 'failed-precondition') {
        setError("Error de consulta: Verifique que existan índices en Firestore para esta consulta.");
      } else if (error.code === 'permission-denied') {
        setError("Error de permisos: No tiene autorización para acceder a estos datos.");
      } else {
        setError("No se pudieron cargar las coordenadas. Intente nuevamente.");
      }
    } finally {
      setCargando(false);
    }
  };

  // Función para cargar usuarios disponibles de la empresa
  const cargarUsuariosDisponibles = async () => {
    if (!usuario?.ruc) return;

    setCargandoUsuarios(true);
    try {
      const usersRef = collection(db, "users");
      const q = query(usersRef, where("rucEmpresa", "==", usuario.ruc));
      const snapshot = await getDocs(q);

      const usuarios = [];
      snapshot.forEach((doc) => {
        const userData = doc.data();
        usuarios.push({
          dni: doc.id,
          nombre: `${userData.name || ''} ${userData.apellidos || ''}`.trim(),
          email: userData.email || '',
          cargo: userData.cargo || '',
          activo: userData.activo !== false,
          ...userData
        });
      });

      setUsuariosDisponibles(usuarios);
    } catch (error) {
      console.error("Error cargando usuarios:", error);
      setError("Error al cargar usuarios de la empresa");
    } finally {
      setCargandoUsuarios(false);
    }
  };

  // Función para cargar usuarios ya asignados a sedes
  const cargarUsuariosAsignados = async () => {
    if (!usuario?.ruc) return;

    try {
      const asignados = {};
      const usersRef = collection(db, "users");
      
      const q = query(
        usersRef, 
        where("rucEmpresa", "==", usuario.ruc),
        limit(500)
      );
      
      const snapshot = await getDocs(q);
      console.log(`📊 Total usuarios encontrados: ${snapshot.docs.length}`);

      const promises = snapshot.docs.map(async (userDoc) => {
        const dni = userDoc.id;
        
        try {
          const coordRef = collection(db, `asistencia/${dni}/coordenadas`);
          const coordQuery = query(
            coordRef,
            where("id_empresa", "==", usuario.ruc),
            where("id_sede_empresa", "!=", null)
          );

          const coordSnap = await getDocs(coordQuery);
          
          coordSnap.forEach((coordDoc) => {
            const coordData = coordDoc.data();
            const sedeId = coordData.id_sede_empresa;

            if (!asignados[sedeId]) {
              asignados[sedeId] = new Map();
            }

            const userData = userDoc.data();
            const grupoNombre = coordData.grupoNombre || null;
            const filaExistente = asignados[sedeId].get(dni);

            // Mismo usuario y misma sede: se agrega a la fila existente en vez
            // de crear una repetida (un trabajador puede tener varios documentos
            // de coordenadas para la misma sede: legacy + asignado por grupo)
            if (filaExistente) {
              if (coordDoc.id && !filaExistente.coordenadaIds.includes(coordDoc.id)) {
                filaExistente.coordenadaIds.push(coordDoc.id);
              }
              if (grupoNombre && !filaExistente.grupos.includes(grupoNombre)) {
                filaExistente.grupos.push(grupoNombre);
              }
              filaExistente.activo = filaExistente.activo || coordData.activo !== false;
              filaExistente.asignadoPorGrupo =
                filaExistente.asignadoPorGrupo || !!coordData.asignadoPorGrupo;
              return;
            }

            asignados[sedeId].set(dni, {
              dni,
              nombre: `${userData.name || ''} ${userData.apellidos || ''}`.trim(),
              email: userData.email || '',
              cargo: userData.cargo || '',
              coordenadaIds: coordDoc.id ? [coordDoc.id] : [],
              coordenadaId: coordDoc.id || null,
              activo: coordData.activo !== false,
              uniqueId: `${dni}`,
              grupos: grupoNombre ? [grupoNombre] : [],
              grupoId: coordData.grupoId || null,
              grupoNombre: grupoNombre,
              asignadoPorGrupo: !!coordData.asignadoPorGrupo
            });
          });
        } catch (coordError) {
          console.warn(`⚠️ Error cargando coordenadas para usuario ${dni}:`, coordError);
        }
      });

      await Promise.all(promises);

      // Los Map por sede se convierten en arrays para el render
      Object.keys(asignados).forEach((sedeId) => {
        asignados[sedeId] = Array.from(asignados[sedeId].values());
      });

      Object.entries(asignados).forEach(([sedeId, usuarios]) => {
        console.log(`🏢 Sede ${sedeId}: ${usuarios.length} usuarios asignados`);
        usuarios.forEach(u => {
          if (u.asignadoPorGrupo) {
            console.log(`   👥 ${u.nombre} (DNI: ${u.dni}) - Grupos: ${(u.grupos || []).join(", ")}`);
          }
        });
      });

      setUsuariosAsignados(asignados);
      console.log(`✅ Total sedes con usuarios: ${Object.keys(asignados).length}`);

    } catch (error) {
      console.error("❌ Error cargando usuarios asignados:", error);
    }
  };

  // ======================== FUNCIONES DE SELECCIÓN MÚLTIPLE ========================

  // Función para manejar selección de usuarios
  const toggleSeleccionUsuario = (sedeId, uniqueId) => {
    setUsuariosSeleccionadosParaEliminar(prev => {
      const usuariosSedeActual = prev[sedeId] || [];
      const yaSeleccionado = usuariosSedeActual.includes(uniqueId);
      
      return {
        ...prev,
        [sedeId]: yaSeleccionado 
          ? usuariosSedeActual.filter(id => id !== uniqueId)
          : [...usuariosSedeActual, uniqueId]
      };
    });
  };

  // Función para seleccionar/deseleccionar todos los usuarios de una sede
  const toggleSeleccionTodosUsuarios = (sedeId, usuarios) => {
    const usuariosActuales = usuariosSeleccionadosParaEliminar[sedeId] || [];
    const todosSeleccionados = usuarios.length > 0 && usuariosActuales.length === usuarios.length;
    
    setUsuariosSeleccionadosParaEliminar(prev => ({
      ...prev,
      [sedeId]: todosSeleccionados ? [] : usuarios.map(u => u.uniqueId)
    }));
  };

  // Función para toggle modo selección múltiple
  const toggleModoSeleccionMultiple = (sedeId) => {
    setModoSeleccionMultiple(prev => ({
      ...prev,
      [sedeId]: !prev[sedeId]
    }));
    
    if (modoSeleccionMultiple[sedeId]) {
      setUsuariosSeleccionadosParaEliminar(prev => ({
        ...prev,
        [sedeId]: []
      }));
    }
  };

  // Función para eliminar usuarios seleccionados masivamente
  const eliminarUsuariosSeleccionados = async (sedeId) => {
    const usuariosAEliminar = usuariosSeleccionadosParaEliminar[sedeId] || [];
    
    if (usuariosAEliminar.length === 0) {
      setError("Debe seleccionar al menos un usuario para eliminar");
      return;
    }

    mostrarConfirmacion(
      `¿Está seguro de eliminar ${usuariosAEliminar.length} usuario(s) de esta sede?`,
      async (confirmado) => {
        if (!confirmado) return;

        setEliminandoMasivo(true);
        try {
          const resultados = {
            exitosos: 0,
            fallidos: 0,
            errores: []
          };

          const usuariosSede = usuariosAsignados[sedeId] || [];
          const usuariosSeleccionadosDetalle = usuariosAEliminar
            .map((uniqueId) => usuariosSede.find((u) => u.uniqueId === uniqueId))
            .filter(Boolean);

          if (usuariosSeleccionadosDetalle.length === 0) {
            setError("No se encontraron las coordenadas seleccionadas para eliminar");
            return;
          }

          const eliminacionesPromises = usuariosSeleccionadosDetalle.map(async (usuarioAsignado) => {
            try {
              const { dni } = usuarioAsignado;
              // Se eliminan TODOS los documentos de coordenadas del usuario en
              // esa sede (legacy + grupo), no solo uno: si no, al recargar la
              // fila seguiría apareciendo
              const coordenadaIds =
                Array.isArray(usuarioAsignado.coordenadaIds) &&
                usuarioAsignado.coordenadaIds.length > 0
                  ? usuarioAsignado.coordenadaIds
                  : [usuarioAsignado.coordenadaId].filter(Boolean);

              if (!dni || coordenadaIds.length === 0) {
                throw new Error("La fila seleccionada no tiene DNI o ID de coordenada");
              }

              let eliminados = 0;
              for (const coordenadaId of coordenadaIds) {
                const coordDocRef = doc(db, `asistencia/${dni}/coordenadas`, coordenadaId);
                const coordSnap = await getDoc(coordDocRef);

                if (!coordSnap.exists()) continue;

                const coordData = coordSnap.data();
                await deleteDoc(coordDocRef);
                eliminados++;

                await addDoc(collection(db, "audit_logs_coordenadas"), {
                  dni: dni,
                  sede_id: coordenadaId,
                  tipo_operacion: "remoción_masiva_de_sede",
                  timestamp: serverTimestamp(),
                  admin_id: usuario?.uid || "unknown",
                  admin_nombre: usuario ? `${usuario.nombre} ${usuario.apellidos}` : "Usuario desconocido",
                  cambios: {
                    sede_removida: {
                      anterior: coordData.nombre,
                      nuevo: null
                    }
                  },
                  motivo: "Usuario removido de la sede mediante eliminación masiva",
                  id_sede_empresa: sedeId
                });
              }

              if (eliminados === 0) {
                throw new Error(`El usuario ${dni} ya no tenía coordenadas en esta sede`);
              }

              resultados.exitosos++;
              console.log(`✅ Usuario ${dni} eliminado correctamente (${eliminados} registro(s))`);

            } catch (error) {
              console.error(`❌ Error eliminando usuario ${usuarioAsignado.uniqueId}:`, error);
              resultados.fallidos++;
              resultados.errores.push(`${usuarioAsignado.uniqueId}: ${error.message}`);
            }
          });

          await Promise.all(eliminacionesPromises);

          if (resultados.exitosos > 0) {
            setMensaje(
              `${resultados.exitosos} usuario(s) eliminado(s) correctamente. ${resultados.fallidos > 0 ? `${resultados.fallidos} fallaron.` : ''}`
            );
          }

          if (resultados.fallidos > 0) {
            setError(`Errores en ${resultados.fallidos} eliminaciones: ${resultados.errores.slice(0, 3).join(', ')}${resultados.errores.length > 3 ? '...' : ''}`);
          }

          setUsuariosSeleccionadosParaEliminar(prev => ({
            ...prev,
            [sedeId]: []
          }));
          
          await cargarUsuariosAsignados();

        } catch (error) {
          console.error("Error en eliminación masiva:", error);
          setError(`Error en eliminación masiva: ${error.message}`);
        } finally {
          setEliminandoMasivo(false);
        }
      }
    );
  };

  // ======================== FUNCIONES DE GUARDADO ========================

  // Función para guardar sede de empresa
  const guardarSedeEmpresa = async (sedeData) => {
    if (!usuario || !usuario.ruc) {
      setError("No se pudo identificar la empresa actual");
      return;
    }

    setCargandoSedeEmpresa(true);

    try {
      const dataToSave = {
        nombre: sedeData.nombre,
        latitud: sedeData.latitud,
        longitud: sedeData.longitud,
        radio: sedeData.radio,
        activo: sedeData.activo,
        updatedAt: serverTimestamp(),
        regimenId: sedeData.regimenId,
        regimenNombre: sedeData.regimenNombre,
        horarioIngreso: sedeData.horarioIngreso || "",
        horarioSalida: sedeData.horarioSalida || "",
        inicioRefrigerio: sedeData.inicioRefrigerio || "",
        finRefrigerio: sedeData.finRefrigerio || "",
      };

      if (sedeData.id) {
        const sedeRef = doc(db, `company_cordenadas/${usuario.ruc}/sedes`, sedeData.id);
        await updateDoc(sedeRef, dataToSave);

        await actualizarCoordenadasUsuariosMasivo(sedeData.id, dataToSave);

        setMensaje(
          `Sede "${sedeData.nombre}" actualizada correctamente. ${usuariosAsignados[sedeData.id]?.length || 0
          } usuario(s) actualizados automáticamente.`
        );
      } else {
        dataToSave.createdAt = serverTimestamp();
        const sedesRef = collection(db, `company_cordenadas/${usuario.ruc}/sedes`);
        await addDoc(sedesRef, dataToSave);
        setMensaje(`Sede "${sedeData.nombre}" creada correctamente`);
      }

      await cargarSedesEmpresa(usuario.ruc);
      await cargarUsuariosAsignados();

    } catch (error) {
      console.error("Error al guardar sede:", error);
      setError(`Error al guardar sede: ${error.message}`);
    } finally {
      setCargandoSedeEmpresa(false);
    }
  };

  // Función para eliminar una sede de la empresa
  const eliminarSedeEmpresa = async (sede) => {
    if (!usuario || !usuario.ruc || !sede?.id) {
      setError("No se pudo identificar la empresa o la sede a eliminar");
      return;
    }

    const usuariosEnSede = (usuariosAsignados[sede.id] || []).length;
    const avisoAsignados =
      usuariosEnSede > 0
        ? `\n\nTiene ${usuariosEnSede} usuario(s) asignado(s): conservarán sus coordenadas ya registradas, pero la sede desaparecerá de la lista. Si quieres quitar esas asignaciones, hazlo desde "Usuarios Asignados".`
        : "";

    mostrarConfirmacion(
      `¿Eliminar la sede "${sede.nombre}"? Esta acción no se puede deshacer.${avisoAsignados}`,
      async () => {
        setCargandoSedeEmpresa(true);

        try {
          const sedeRef = doc(db, `company_cordenadas/${usuario.ruc}/sedes`, sede.id);
          const sedeSnap = await getDoc(sedeRef);

          if (!sedeSnap.exists()) {
            throw new Error("La sede ya no existe");
          }

          const sedeData = sedeSnap.data();
          await deleteDoc(sedeRef);

          await addDoc(collection(db, "audit_logs_coordenadas"), {
            dni: null,
            sede_id: sede.id,
            tipo_operacion: "eliminación_de_sede",
            timestamp: serverTimestamp(),
            admin_id: usuario?.uid || "unknown",
            admin_nombre: usuario ? `${usuario.nombre} ${usuario.apellidos}` : "Usuario desconocido",
            cambios: {
              sede_eliminada: {
                anterior: {
                  nombre: sedeData.nombre,
                  latitud: sedeData.latitud,
                  longitud: sedeData.longitud,
                  radio: sedeData.radio,
                  activo: sedeData.activo
                },
                nuevo: null
              }
            },
            motivo: "Sede eliminada desde el panel de asistencias",
            usuarios_asignados_al_momento: usuariosEnSede
          });

          setMensaje(`Sede "${sedeData.nombre}" eliminada correctamente`);
          await cargarSedesEmpresa(usuario.ruc);
          await cargarUsuariosAsignados();

        } catch (error) {
          console.error("Error al eliminar sede:", error);
          setError(`Error al eliminar sede: ${error.message}`);
        } finally {
          setCargandoSedeEmpresa(false);
        }
      }
    );
  };

  // Función para actualizar coordenadas de usuarios en masa
  const actualizarCoordenadasUsuariosMasivo = async (sedeId, sedeData) => {
    try {
      const usersRef = collection(db, "users");
      const q = query(usersRef, where("rucEmpresa", "==", usuario.ruc));
      const snapshot = await getDocs(q);

      const actualizacionesPromises = [];

      for (const userDoc of snapshot.docs) {
        const dni = userDoc.id;
        const coordRef = collection(db, `asistencia/${dni}/coordenadas`);
        const coordQuery = query(
          coordRef,
          where("id_sede_empresa", "==", sedeId),
          where("id_empresa", "==", usuario.ruc)
        );

        const coordSnap = await getDocs(coordQuery);

        coordSnap.forEach((coordDoc) => {
          const actualizacion = updateDoc(coordDoc.ref, {
            nombre: sedeData.nombre,
            latitud: sedeData.latitud,
            longitud: sedeData.longitud,
            radio: sedeData.radio,
            horarioIngreso: sedeData.horarioIngreso,
            horarioSalida: sedeData.horarioSalida,
            inicioRefrigerio: sedeData.inicioRefrigerio,
            finRefrigerio: sedeData.finRefrigerio,
            regimenId: sedeData.regimenId,
            regimenNombre: sedeData.regimenNombre,
            updatedAt: serverTimestamp(),
          });

          actualizacionesPromises.push(actualizacion);

          const auditoria = addDoc(collection(db, "audit_logs_coordenadas"), {
            dni: dni,
            sede_id: coordDoc.id,
            tipo_operacion: "actualización_automatica_sede",
            timestamp: serverTimestamp(),
            admin_id: usuario?.uid || "system",
            admin_nombre: usuario ? `${usuario.nombre} ${usuario.apellidos}` : "Sistema",
            cambios: {
              sede_actualizada: {
                anterior: "datos_anteriores",
                nuevo: sedeData.nombre
              }
            },
            motivo: `Actualización automática por cambio en sede: ${sedeData.nombre}`,
            id_sede_empresa: sedeId
          });

          actualizacionesPromises.push(auditoria);
        });
      }

      await Promise.all(actualizacionesPromises);
      console.log(`✅ Actualizadas ${actualizacionesPromises.length / 2} coordenadas automáticamente`);

    } catch (error) {
      console.error("Error actualizando coordenadas de usuarios:", error);
      throw error;
    }
  };

  // Función para guardar coordenada individual
  const guardarCoordenada = async () => {
    if (
      !datosUsuario ||
      !datosUsuario.dni ||
      !nombreSede ||
      !latitud ||
      !longitud ||
      !radio ||
      !nombreEmpresa ||
      !idEmpresa
    ) {
      setError("Por favor complete todos los campos obligatorios");
      return;
    }

    if (modoEdicion && !motivoCambio) {
      setError("Por favor ingrese el motivo del cambio para la auditoría");
      return;
    }

    if (incluyeHorario) {
      if (!horarioIngreso) {
        setError("El horario de ingreso es obligatorio cuando se incluyen horarios");
        return;
      }
      if (!horarioSalida) {
        setError("El horario de salida es obligatorio cuando se incluyen horarios");
        return;
      }
    }

    setCargando(true);
    setError("");

    try {
      const coordenadaData = {
        latitud: Number(latitud),
        longitud: Number(longitud),
        radio: Number(radio),
        nombre: nombreSede,
        empresa: nombreEmpresa,
        id_empresa: idEmpresa,
        prioridad: Number(prioridad),
        activo: activo,
        ultimoUso: serverTimestamp(),
      };

      if (incluyeHorario) {
        coordenadaData.horarioIngreso = horarioIngreso || "";
        coordenadaData.horarioSalida = horarioSalida || "";
        coordenadaData.inicioRefrigerio = inicioRefrigerio || "";
        coordenadaData.finRefrigerio = finRefrigerio || "";
      } else {
        coordenadaData.horarioIngreso = null;
        coordenadaData.horarioSalida = null;
        coordenadaData.inicioRefrigerio = null;
        coordenadaData.finRefrigerio = null;
      }

      let docRef;
      let datosPrevios = {};

      if (modoEdicion) {
        docRef = doc(db, `asistencia/${datosUsuario.dni}/coordenadas`, idSede);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          datosPrevios = docSnap.data();
        }
        await updateDoc(docRef, coordenadaData);
        setMensaje(`Coordenada para ${nombreSede} actualizada correctamente`);
      } else {
        docRef = doc(collection(db, `asistencia/${datosUsuario.dni}/coordenadas`));
        coordenadaData.createdAt = serverTimestamp();
        await setDoc(docRef, coordenadaData);
        setMensaje(`Coordenada para ${nombreSede} creada correctamente`);
      }

      await registrarAuditoria(
        datosUsuario.dni,
        docRef.id,
        modoEdicion ? "actualización" : "creación",
        datosPrevios,
        coordenadaData
      );

      await cargarCoordenadas();
      setModalVisible(false);
      limpiarFormulario();
    } catch (error) {
      console.error("Error al guardar coordenada:", error);
      setError(`Error al guardar: ${error.message}`);
    } finally {
      setCargando(false);
    }
  };

  // ======================== FUNCIONES DE BÚSQUEDA Y NAVEGACIÓN ========================

  // Función para buscar trabajador por DNI
  const buscarPorDNI = async () => {
    if (!dni.trim() || dni.length < 8) {
      setError("Ingrese un número de DNI válido");
      return;
    }

    try {
      setBuscando(true);
      setError(null);
      setCoordenadas([]);
      setDatosUsuario(null);

      const userRef = doc(db, "users", dni.trim());
      const userSnap = await getDoc(userRef);

      if (userSnap.exists()) {
        const userData = userSnap.data();
        setDatosUsuario({
          ...userData,
          dni: dni.trim(),
        });
        setMensaje(`Trabajador encontrado: ${userData.name} ${userData.apellidos || ""}`);
      } else {
        console.warn(`No se encontró usuario con DNI: ${dni}`);
        setError(`No se encontró usuario con DNI: ${dni}`);
        setBuscando(false);
        return;
      }

      await cargarCoordenadas();
    } catch (error) {
      console.error("Error al buscar:", error);
      setError(`Error al buscar trabajador: ${error.message}`);
    } finally {
      setBuscando(false);
    }
  };

  // ======================== FUNCIONES DE ASIGNACIÓN MASIVA ========================

  // Función para mostrar modal de asignación masiva
  const mostrarAsignacionMasiva = (sede) => {
    setSedeParaAsignar(sede);
    setUsuariosSeleccionados([]);
    setGruposSeleccionados([]);
    setModoAsignacion("individual");
    setModalAsignacionMasiva(true);
    cargarUsuariosDisponibles();
    cargarGruposEmpresa();
  };

  // Función para asignar sede a grupos seleccionados
  const asignarSedeAGrupos = async () => {
    if (!sedeParaAsignar || gruposSeleccionados.length === 0) {
      setError("Debe seleccionar al menos un grupo");
      return;
    }

    setAsignandoGrupos(true);

    try {
      const resultados = {
        exitosos: 0,
        fallidos: 0,
        errores: [],
        usuariosAsignados: []
      };

      console.log(`🚀 Iniciando asignación para ${gruposSeleccionados.length} grupos`);

      for (const grupoId of gruposSeleccionados) {
        const grupo = gruposEmpresa.find(g => g.id === grupoId);
        if (!grupo) {
          console.warn(`⚠️ Grupo ${grupoId} no encontrado`);
          continue;
        }

        console.log(`👥 Procesando grupo: ${grupo.name} con ${grupo.members.length} miembros`);

        const miembrosPromises = grupo.members.map(async (dni) => {
          try {
            const userRef = doc(db, "users", dni);
            const userSnap = await getDoc(userRef);

            if (!userSnap.exists()) {
              throw new Error(`Usuario ${dni} no encontrado`);
            }

            const coordRef = collection(db, `asistencia/${dni}/coordenadas`);
            const existeQuery = query(
              coordRef,
              where("id_sede_empresa", "==", sedeParaAsignar.id),
              where("id_empresa", "==", usuario.ruc)
            );

            const existeSnap = await getDocs(existeQuery);
            const yaEstaba = !existeSnap.empty;

            if (yaEstaba) {
              console.log(`ℹ️ Usuario ${dni} ya tiene asignada la sede ${sedeParaAsignar.nombre}`);
            }

            // Documento canónico `${dni}_${sedeId}`: si ya la tenía, la
            // procedencia del grupo se acumula en el MISMO documento (antes se
            // creaba otro documento y el usuario salía repetido)
            const resultado = await asignarSedeAUsuario({
              dni,
              ruc: usuario.ruc,
              sede: sedeParaAsignar,
              companyName: usuario.empresa || "Mi Empresa",
              grupoId: grupo.id,
              grupoNombre: grupo.name,
              extra: { activo: true },
            });

            await addDoc(collection(db, "audit_logs_coordenadas"), {
              dni: dni,
              sede_id: resultado.id,
              tipo_operacion: "asignación_por_grupo",
              timestamp: serverTimestamp(),
              admin_id: usuario?.uid || "unknown",
              admin_nombre: usuario ? `${usuario.nombre} ${usuario.apellidos}` : "Usuario desconocido",
              cambios: {
                sede_asignada: {
                  anterior: null,
                  nuevo: sedeParaAsignar.nombre
                },
                grupo_asignado: {
                  anterior: null,
                  nuevo: `${grupo.name} (${grupo.id})`
                }
              },
              motivo: `Asignación por grupo: ${grupo.name} -> ${sedeParaAsignar.nombre}`,
              id_sede_empresa: sedeParaAsignar.id,
              grupo_id: grupo.id,
              grupo_nombre: grupo.name
            });

            console.log(`✅ Usuario ${dni} asignado exitosamente`);

            return {
              success: true,
              dni,
              nombre: `${userSnap.data().name || ''} ${userSnap.data().apellidos || ''}`.trim(),
              grupo: grupo.name,
              skipReason: yaEstaba ? "already_assigned" : undefined
            };

          } catch (error) {
            console.error(`❌ Error asignando sede a usuario ${dni}:`, error);
            return {
              success: false,
              dni,
              error: error.message
            };
          }
        });

        const resultadosMiembros = await Promise.all(miembrosPromises);

        resultadosMiembros.forEach(resultado => {
          if (resultado.success) {
            resultados.exitosos++;
            if (resultado.skipReason !== 'already_assigned') {
              resultados.usuariosAsignados.push(resultado);
            }
          } else {
            resultados.fallidos++;
            resultados.errores.push(`${resultado.dni}: ${resultado.error}`);
          }
        });
      }

      console.log(`📊 Resultados finales:`, resultados);

      if (resultados.exitosos > 0) {
        setMensaje(
          `Sede asignada exitosamente a ${resultados.exitosos} usuario(s) de ${gruposSeleccionados.length} grupo(s). ${resultados.fallidos > 0 ? `${resultados.fallidos} fallaron.` : ''}`
        );
      }

      if (resultados.fallidos > 0) {
        setError(`Errores en ${resultados.fallidos} asignaciones: ${resultados.errores.slice(0, 5).join(', ')}${resultados.errores.length > 5 ? '...' : ''}`);
      }

      setTimeout(async () => {
        await cargarUsuariosAsignados();
      }, 1000);
      
      setModalAsignacionMasiva(false);

    } catch (error) {
      console.error("❌ Error en asignación por grupos:", error);
      setError(`Error en asignación por grupos: ${error.message}`);
    } finally {
      setAsignandoGrupos(false);
    }
  };

  // Función para asignar sede a usuarios seleccionados
  const asignarSedeAUsuarios = async () => {
    if (!sedeParaAsignar || usuariosSeleccionados.length === 0) {
      setError("Debe seleccionar al menos un usuario");
      return;
    }

    setAsignandoMasivo(true);

    try {
      const resultados = {
        exitosos: 0,
        fallidos: 0,
        errores: []
      };

      for (const dni of usuariosSeleccionados) {
        try {
          // Documento canónico `${dni}_${sedeId}`: reasignar la misma sede
          // actualiza el documento existente en vez de duplicarlo
          const resultado = await asignarSedeAUsuario({
            dni,
            ruc: usuario.ruc,
            sede: sedeParaAsignar,
            companyName: usuario.empresa || "Mi Empresa",
            individual: true,
            extra: { activo: true },
          });

          await addDoc(collection(db, "audit_logs_coordenadas"), {
            dni: dni,
            sede_id: resultado.id,
            tipo_operacion: resultado.creado ? "asignación_individual" : "actualización_individual",
            timestamp: serverTimestamp(),
            admin_id: usuario?.uid || "unknown",
            admin_nombre: usuario ? `${usuario.nombre} ${usuario.apellidos}` : "Usuario desconocido",
            cambios: {
              sede_asignada: {
                anterior: null,
                nuevo: sedeParaAsignar.nombre
              }
            },
            motivo: `Asignación individual de sede: ${sedeParaAsignar.nombre}`,
            id_sede_empresa: sedeParaAsignar.id
          });

          resultados.exitosos++;
        } catch (error) {
          console.error(`Error asignando sede a usuario ${dni}:`, error);
          resultados.fallidos++;
          resultados.errores.push(`${dni}: ${error.message}`);
        }
      }

      if (resultados.exitosos > 0) {
        setMensaje(
          `Sede asignada exitosamente a ${resultados.exitosos} usuario(s). ${resultados.fallidos > 0 ? `${resultados.fallidos} fallaron.` : ''}`
        );
      }

      if (resultados.fallidos > 0) {
        setError(`Errores en ${resultados.fallidos} asignaciones: ${resultados.errores.join(', ')}`);
      }

      await cargarUsuariosAsignados();
      setModalAsignacionMasiva(false);

    } catch (error) {
      console.error("Error en asignación masiva:", error);
      setError(`Error en asignación masiva: ${error.message}`);
    } finally {
      setAsignandoMasivo(false);
    }
  };

  // Función para aplicar sede a un trabajador específico
  const aplicarSedeATrabajador = async (sede) => {
    if (!datosUsuario || !datosUsuario.dni) {
      setError("Primero debe buscar un trabajador");
      return;
    }

    setCargando(true);
    setModalSedesVisible(false);

    try {
      const coordenadaData = {
        latitud: sede.latitud,
        longitud: sede.longitud,
        radio: sede.radio,
        nombre: sede.nombre,
        empresa: usuario.empresa || "Mi Empresa",
        id_empresa: usuario.ruc,
        prioridad: 1,
        activo: true,
        ultimoUso: serverTimestamp(),
        createdAt: serverTimestamp(),
        id_sede_empresa: sede.id,
        asignadoPorGrupo: false,
      };

      const tieneAlgunHorario = sede.horarioIngreso || sede.horarioSalida ||
        sede.inicioRefrigerio || sede.finRefrigerio;

      if (tieneAlgunHorario) {
        coordenadaData.horarioIngreso = sede.horarioIngreso || "";
        coordenadaData.horarioSalida = sede.horarioSalida || "";
        coordenadaData.inicioRefrigerio = sede.inicioRefrigerio || "";
        coordenadaData.finRefrigerio = sede.finRefrigerio || "";
      }

      // Documento canónico `${dni}_${sedeId}`: si el trabajador ya tenía esta
      // sede, se actualiza ese mismo documento. Antes cada "Aplicar" creaba un
      // documento nuevo con ID aleatorio (el origen de las filas repetidas).
      const resultado = await asignarSedeAUsuario({
        dni: datosUsuario.dni,
        ruc: usuario.ruc,
        sede,
        companyName: usuario.empresa || "Mi Empresa",
        individual: true,
        extra: { activo: true },
      });

      await registrarAuditoria(
        datosUsuario.dni,
        resultado.id,
        resultado.creado ? "creación" : "actualización",
        resultado.previo || {},
        coordenadaData
      );

      setMensaje(
        `Sede "${sede.nombre}" ${resultado.creado ? "aplicada" : "actualizada"} correctamente al trabajador ${datosUsuario.name}`
      );

      await cargarCoordenadas();
    } catch (error) {
      console.error("Error al aplicar sede:", error);
      setError(`Error al aplicar sede: ${error.message}`);
    } finally {
      setCargando(false);
    }
  };

  // ======================== FUNCIONES DE GESTIÓN DE ESTADOS ========================

  // Función para cambiar estado de coordenada
  const cambiarEstadoCoordenada = async (coordenada, nuevoEstado) => {
    setError("");

    mostrarPrompt(
      `Por favor, ingrese el motivo para ${nuevoEstado ? "activar" : "desactivar"} esta coordenada:`,
      async (motivo) => {
        if (!motivo) {
          setError("Se requiere un motivo para realizar este cambio.");
          return;
        }

        setCargando(true);

        try {
          const docRef = doc(db, `asistencia/${coordenada.dni}/coordenadas`, coordenada.id);
          const docSnap = await getDoc(docRef);
          const datosPrevios = docSnap.exists() ? docSnap.data() : {};

          await updateDoc(docRef, {
            activo: nuevoEstado,
            ultimoUso: serverTimestamp(),
          });

          await registrarAuditoria(
            coordenada.dni,
            coordenada.id,
            "cambio de estado",
            datosPrevios,
            { ...datosPrevios, activo: nuevoEstado }
          );

          setMensaje(`Coordenada ${nuevoEstado ? "activada" : "desactivada"} correctamente`);
          await cargarCoordenadas();
        } catch (error) {
          console.error("Error al cambiar estado:", error);
          setError(`Error al cambiar estado: ${error.message}`);
        } finally {
          setCargando(false);
        }
      }
    );
  };

  // Función para remover usuario de una sede
  const removerUsuarioDeSede = async (sedeId, usuarioAsignado) => {
    mostrarConfirmacion(
      "¿Está seguro de remover al usuario de esta sede?",
      async (confirmado) => {
        if (!confirmado) return;

        setCargando(true);
        try {
          const dni = usuarioAsignado?.dni;
          // Un usuario puede tener varios documentos de coordenadas para la
          // misma sede (legacy + grupo): se eliminan todos para que la remoción
          // sea real y no quede una fila "fantasma" al recargar
          const coordenadaIds =
            Array.isArray(usuarioAsignado?.coordenadaIds) &&
            usuarioAsignado.coordenadaIds.length > 0
              ? usuarioAsignado.coordenadaIds
              : [usuarioAsignado?.coordenadaId].filter(Boolean);

          if (!dni || coordenadaIds.length === 0) {
            throw new Error("La fila seleccionada no tiene DNI o ID de coordenada");
          }

          let eliminados = 0;
          for (const coordenadaId of coordenadaIds) {
            const coordDocRef = doc(db, `asistencia/${dni}/coordenadas`, coordenadaId);
            const coordSnap = await getDoc(coordDocRef);

            if (!coordSnap.exists()) continue;

            const coordData = coordSnap.data();
            await deleteDoc(coordDocRef);
            eliminados++;

            await addDoc(collection(db, "audit_logs_coordenadas"), {
              dni: dni,
              sede_id: coordenadaId,
              tipo_operacion: "remoción_de_sede",
              timestamp: serverTimestamp(),
              admin_id: usuario?.uid || "unknown",
              admin_nombre: usuario ? `${usuario.nombre} ${usuario.apellidos}` : "Usuario desconocido",
              cambios: {
                sede_removida: {
                  anterior: coordData.nombre,
                  nuevo: null
                }
              },
              motivo: "Usuario removido de la sede manualmente",
              id_sede_empresa: sedeId
            });
          }

          if (eliminados === 0) {
            throw new Error("La coordenada seleccionada ya no existe");
          }

          setMensaje(
            eliminados > 1
              ? `Usuario removido de la sede correctamente (${eliminados} registros eliminados)`
              : "Usuario removido de la sede correctamente"
          );
          await cargarUsuariosAsignados();

        } catch (error) {
          console.error("Error removiendo usuario:", error);
          setError(`Error al remover usuario: ${error.message}`);
        } finally {
          setCargando(false);
        }
      }
    );
  };

  // ======================== FUNCIONES DE MODAL Y FORMULARIO ========================

  // Función para mostrar modal de creación
  const mostrarModalCreacion = () => {
    if (!datosUsuario) {
      setError("Primero debe buscar un trabajador");
      return;
    }

    limpiarFormulario();

    if (usuario && usuario.ruc) {
      setIdEmpresa(usuario.ruc);
      const empresaActual = empresas.find((e) => e.id === usuario.ruc);
      if (empresaActual) {
        setNombreEmpresa(empresaActual.nombre);
      } else {
        setNombreEmpresa(usuario.empresa || "Mi Empresa");
      }
    }

    setModoEdicion(false);
    setModalVisible(true);
  };

  // Función para mostrar modal de edición
  const mostrarModalEdicion = (coordenada) => {
    setCoordenadaActual(coordenada);
    setNombreSede(coordenada.nombre);
    setLatitud(coordenada.latitud);
    setLongitud(coordenada.longitud);
    setRadio(coordenada.radio);
    setNombreEmpresa(coordenada.empresa);
    setIdEmpresa(coordenada.id_empresa);
    setPrioridad(coordenada.prioridad);
    setActivo(coordenada.activo);
    setIdSede(coordenada.id);
    setHorarioIngreso(coordenada.horarioIngreso || "");
    setHorarioSalida(coordenada.horarioSalida || "");
    setInicioRefrigerio(coordenada.inicioRefrigerio || "");
    setFinRefrigerio(coordenada.finRefrigerio || "");
    setIncluyeHorario(!!coordenada.horarioIngreso);
    setModoEdicion(true);
    setModalVisible(true);
  };

  // Función para limpiar formulario
  const limpiarFormulario = () => {
    setNombreSede("");
    setLatitud(0);
    setLongitud(0);
    setRadio(100);
    setNombreEmpresa("");
    setIdEmpresa("");
    setPrioridad(1);
    setActivo(true);
    setIdSede("");
    setMotivoCambio("");
    setHorarioIngreso("");
    setHorarioSalida("");
    setInicioRefrigerio("");
    setFinRefrigerio("");
    setIncluyeHorario(false);
  };

  // ======================== FUNCIONES DE AUDITORÍA E HISTORIAL ========================

  // Función para registrar auditoría
  const registrarAuditoria = async (dni, sedeId, tipoOperacion, valorAnterior, valorNuevo) => {
    try {
      const cambios = {};

      if (tipoOperacion === "actualización") {
        const camposAComparar = [
          "latitud", "longitud", "radio", "nombre", "empresa", "id_empresa",
          "prioridad", "activo", "horarioIngreso", "horarioSalida",
          "inicioRefrigerio", "finRefrigerio",
        ];

        camposAComparar.forEach((campo) => {
          if (JSON.stringify(valorAnterior[campo]) !== JSON.stringify(valorNuevo[campo])) {
            cambios[campo] = {
              anterior: valorAnterior[campo],
              nuevo: valorNuevo[campo],
            };
          }
        });
      } else {
        Object.keys(valorNuevo).forEach((campo) => {
          if (campo !== "createdAt" && campo !== "ultimoUso") {
            cambios[campo] = {
              anterior: null,
              nuevo: valorNuevo[campo],
            };
          }
        });
      }

      await addDoc(collection(db, "audit_logs_coordenadas"), {
        dni: dni,
        sede_id: sedeId,
        tipo_operacion: tipoOperacion,
        timestamp: serverTimestamp(),
        admin_id: usuario ? usuario.uid : "unknown",
        admin_nombre: usuario ? `${usuario.nombre} ${usuario.apellidos}` : "Usuario desconocido",
        cambios: cambios,
        motivo: motivoCambio || "Creación inicial",
      });
    } catch (error) {
      console.error("Error al registrar auditoría:", error);
    }
  };

      // Función para cargar historial de una coordenada
    const cargarHistorial = async (coordenada) => {
      setCargando(true);
      setError("");
  
      try {
        const historialRef = collection(db, "audit_logs_coordenadas");
  
        const historialQuery = query(
          historialRef,
          where("sede_id", "==", coordenada.id),
          where("dni", "==", coordenada.dni),
          orderBy("timestamp", "desc"),
          limit(50)
        );
  
        const snapshot = await getDocs(historialQuery);
        const historiales = [];
  
        snapshot.forEach((doc) => {
          const data = doc.data();
          historiales.push({
            id: doc.id,
            ...data,
            timestamp: data.timestamp?.toDate() || new Date(),
          });
        });
  
        setHistorialCoordenada(historiales);
        setHistorialVisible(true);
  
        console.log(`✅ Cargado historial: ${historiales.length} registros`);
  
      } catch (error) {
        console.error("Error al cargar historial:", error);
  
        if (error.code === 'failed-precondition') {
          setError("Error: Se requiere crear un índice en Firestore para esta consulta de historial.");
        } else if (error.code === 'permission-denied') {
          setError("Error: No tiene permisos para acceder al historial de auditoría.");
        } else {
          setError("Error al cargar historial. Intente nuevamente.");
        }
      } finally {
        setCargando(false);
      }
    };
  
    // ======================== FUNCIONES DE RENDERIZADO ========================
  
    // Función para renderizar cambios en el historial
    const renderizarCambios = (cambios) => {
      if (!cambios || Object.keys(cambios).length === 0) {
        return <small className="text-muted">Sin cambios específicos registrados</small>;
      }
  
      return (
        <div className="mt-2">
          {Object.entries(cambios).map(([campo, cambio]) => (
            <div key={campo} className="mb-1">
              <strong>{campo}:</strong>{" "}
              <span className="text-danger">
                {cambio.anterior ? String(cambio.anterior) : "null"}
              </span>{" "}
              → <span className="text-success">{String(cambio.nuevo)}</span>
            </div>
          ))}
        </div>
      );
    };
  
    // Función para formatear fecha
    const formatearFecha = (fecha) => {
      if (!fecha) return "Sin fecha";
      return new Date(fecha).toLocaleString("es-ES", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
      });
    };
  
    // ======================== MANEJO DE EVENTOS ========================
  
    // Función para manejar tecla Enter
    const manejarKeyPress = (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        buscarPorDNI();
      }
    };
  
    // Función para limpiar mensajes después de cierto tiempo
    useEffect(() => {
      if (mensaje) {
        const timer = setTimeout(() => {
          setMensaje("");
        }, 5000);
        return () => clearTimeout(timer);
      }
    }, [mensaje]);
  
    useEffect(() => {
      if (error) {
        const timer = setTimeout(() => {
          setError("");
        }, 8000);
        return () => clearTimeout(timer);
      }
    }, [error]);
  
    // ======================== COMPONENTE PRINCIPAL - RENDER ========================
  
    return (
      <Container fluid className="p-4">
        <Card
          className="shadow-lg border-0"
          style={{ borderRadius: "15px", overflow: "hidden", minHeight: "90vh" }}
        >
          {/* Header Premium con degradado verde oscuro */}
          <Card.Header
            className="text-white py-4 position-relative"
            style={{
              background: "linear-gradient(135deg, #0d4f3c 0%, #2c7a2c 100%)",
              borderBottom: "3px solid #f39c12",
              borderRadius: "15px 15px 0 0",
            }}
          >
            <div
              className="position-absolute end-0 top-50 translate-middle-y me-4"
              style={{ zIndex: 10 }}
            >
              <BotonManualHeader usuario={usuario} />
            </div>
            <div className="text-center">
              <h2 className="fw-bold mb-1">
                <FaMapMarkerAlt className="me-3" />
                Gestión de Coordenadas y Sedes
              </h2>
              <p className="mb-0 opacity-75">
                Configura puntos geolocalizados y perímetros de marcación | RUC:{" "}
                {usuario?.ruc || "–"}
              </p>
            </div>
          </Card.Header>

          <Card.Body>
            {/* Acciones Rápidas */}
            <Card
              className="border-0 mb-4"
              style={{
                background: "linear-gradient(135deg,#fffcea,#fff9db)",
                borderRadius: 14,
                boxShadow: "0 2px 12px rgba(109,40,217,.07)",
              }}
            >
              <Card.Body className="p-3 d-flex justify-content-center gap-3 flex-wrap">
                <Button
                  variant="outline-dark"
                  onClick={() => window.location.reload()}
                  disabled={cargando}
                  className="d-flex align-items-center gap-2 bg-white"
                  style={{
                    borderRadius: "10px",
                    padding: "10px 20px",
                    fontWeight: "bold",
                  }}
                >
                  <FaSync className={cargando ? "fa-spin" : ""} />
                  {cargando ? " Cargando..." : " Actualizar Datos"}
                </Button>

                <Button
                  variant="success"
                  onClick={() => {
                    setSedeEmpresaActual(null);
                    setModalSedeEmpresaVisible(true);
                  }}
                  className="d-flex align-items-center gap-2"
                  style={{
                    borderRadius: "10px",
                    background: "linear-gradient(135deg, #28a745 0%, #20c997 100%)",
                    border: "none",
                    padding: "10px 20px",
                    fontWeight: "bold",
                    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                  }}
                >
                  <FaPlusCircle size="16px" />
                  Nueva Sede de Empresa
                </Button>
              </Card.Body>
            </Card>

            {/* Mensajes de error y éxito */}
            {error && (
              <Alert variant="danger" className="mb-3" dismissible onClose={() => setError("")}>
                <FaExclamationTriangle className="me-2" />
                {error}
              </Alert>
            )}
  
            {mensaje && (
              <Alert variant="success" className="mb-3" dismissible onClose={() => setMensaje("")}>
                <FaCheck className="me-2" />
                {mensaje}
              </Alert>
            )}
  
            {/* Tabs principales */}
            <Tabs defaultActiveKey="trabajador" id="asistencia-tabs" className="mb-3">
              
              {/* Tab 1: Búsqueda de trabajador */}
              <Tab eventKey="trabajador" title="Buscar Trabajador">
                <div className="p-3">
                  <Row>
                    <Col md={6}>
                      <Card>
                        <Card.Header>
                          <h5>
                            <FaSearch className="me-2" />
                            Búsqueda por DNI
                          </h5>
                        </Card.Header>
                        <Card.Body>
                          <Form onSubmit={(e) => { e.preventDefault(); buscarPorDNI(); }}>
                            <InputGroup className="mb-3">
                              <InputGroup.Text>
                                <FaIdCard />
                              </InputGroup.Text>
                              <Form.Control
                                type="text"
                                placeholder="Ingrese DNI del trabajador"
                                value={dni}
                                onChange={(e) => setDni(e.target.value)}
                                onKeyPress={manejarKeyPress}
                                maxLength={8}
                                disabled={buscando}
                              />
                              <Button
                                variant="primary"
                                onClick={buscarPorDNI}
                                disabled={buscando || !dni.trim()}
                              >
                                {buscando ? (
                                  <Spinner animation="border" size="sm" className="me-2" />
                                ) : (
                                  <FaSearch className="me-2" />
                                )}
                                {buscando ? "Buscando..." : "Buscar"}
                              </Button>
                            </InputGroup>
                          </Form>
                        </Card.Body>
                      </Card>
                    </Col>
  
                    <Col md={6}>
                      {datosUsuario && (
                        <Card>
                          <Card.Header>
                            <h5>
                              <FaUser className="me-2" />
                              Información del Trabajador
                            </h5>
                          </Card.Header>
                          <Card.Body>
                            <div className="mb-2">
                              <strong>Nombre:</strong> {datosUsuario.name} {datosUsuario.apellidos}
                            </div>
                            <div className="mb-2">
                              <strong>DNI:</strong> {datosUsuario.dni}
                            </div>
                            <div className="mb-2">
                              <strong>Email:</strong> {datosUsuario.email || "No disponible"}
                            </div>
                            <div className="mb-2">
                              <strong>Cargo:</strong> {datosUsuario.cargo || "No especificado"}
                            </div>
                            <div className="mb-2">
                              <strong>Estado:</strong>{" "}
                              <Badge bg={datosUsuario.activo !== false ? "success" : "danger"}>
                                {datosUsuario.activo !== false ? "Activo" : "Inactivo"}
                              </Badge>
                            </div>
                            <div className="mt-3">
                              <Button
                                variant="primary"
                                size="sm"
                                onClick={mostrarModalCreacion}
                                className="me-2"
                              >
                                <FaPlusCircle className="me-1" />
                                Nueva Coordenada
                              </Button>
                              <Button
                                variant="outline-secondary"
                                size="sm"
                                onClick={() => setModalSedesVisible(true)}
                                disabled={cargandoSedes}
                              >
                                <FaBuilding className="me-1" />
                                Sedes Disponibles
                              </Button>
                            </div>
                          </Card.Body>
                        </Card>
                      )}
                    </Col>
                  </Row>
  
                  {/* Tabla de coordenadas del trabajador */}
                  {datosUsuario && (
                    <div className="mt-4">
                      <Card>
                        <Card.Header>
                          <div className="d-flex justify-content-between align-items-center">
                            <h5>
                              <FaMapMarkerAlt className="me-2" />
                              Coordenadas Asignadas
                            </h5>
                            <div className="d-flex gap-2">
                              <Form.Select
                                size="sm"
                                value={filtroActivo}
                                onChange={(e) => setFiltroActivo(e.target.value === "true")}
                                style={{ width: "auto" }}
                              >
                                <option value="true">Solo Activos</option>
                                <option value="false">Solo Inactivos</option>
                              </Form.Select>
                            </div>
                          </div>
                        </Card.Header>
                        <Card.Body>
                          {cargando ? (
                            <div className="text-center p-4">
                              <Spinner animation="border" />
                              <p className="mt-2">Cargando coordenadas...</p>
                            </div>
                          ) : coordenadas.length === 0 ? (
                            <Alert variant="info">
                              <FaInfoCircle className="me-2" />
                              No se encontraron coordenadas para este trabajador.
                            </Alert>
                          ) : (
                            <div className="table-responsive">
                              <Table striped bordered hover>
                                <thead>
                                  <tr>
                                    <th>Sede</th>
                                    <th>Empresa</th>
                                    <th>Coordenadas</th>
                                    <th>Radio</th>
                                    <th>Prioridad</th>
                                    <th>Horarios</th>
                                    <th>Grupo</th>
                                    <th>Estado</th>
                                    <th>Acciones</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {coordenadas.map((coordenada) => (
                                    <tr key={coordenada.id}>
                                      <td>
                                        <strong>{coordenada.nombre}</strong>
                                      </td>
                                      <td>{coordenada.empresa}</td>
                                      <td>
                                        <small>
                                          Lat: {coordenada.latitud}<br />
                                          Lng: {coordenada.longitud}
                                        </small>
                                      </td>
                                      <td>{coordenada.radio}m</td>
                                      <td>
                                        <Badge bg="secondary">{coordenada.prioridad}</Badge>
                                      </td>
                                      <td>
                                        <small>
                                          {coordenada.horarioIngreso && coordenada.horarioSalida ? (
                                            <>
                                              <FaClock className="me-1" />
                                              {coordenada.horarioIngreso} - {coordenada.horarioSalida}
                                              {coordenada.inicioRefrigerio && coordenada.finRefrigerio && (
                                                <div className="text-muted">
                                                  Ref: {coordenada.inicioRefrigerio} - {coordenada.finRefrigerio}
                                                </div>
                                              )}
                                            </>
                                          ) : (
                                            "Sin horarios"
                                          )}
                                        </small>
                                      </td>
                                      <td>
                                        {coordenada.asignadoPorGrupo ? (
                                          <small className="text-info">
                                            <FaCogs className="me-1" />
                                            {coordenada.grupoNombre}
                                          </small>
                                        ) : (
                                          <small className="text-muted">Individual</small>
                                        )}
                                      </td>
                                      <td>
                                        <Badge bg={coordenada.activo ? "success" : "danger"}>
                                          {coordenada.activo ? "Activo" : "Inactivo"}
                                        </Badge>
                                      </td>
                                      <td>
                                        <div className="d-flex gap-1">
                                          <Button
                                            variant="outline-primary"
                                            size="sm"
                                            onClick={() => mostrarModalEdicion(coordenada)}
                                          >
                                            <FaEdit />
                                          </Button>
                                          <Button
                                            variant="outline-info"
                                            size="sm"
                                            onClick={() => cargarHistorial(coordenada)}
                                          >
                                            <FaHistory />
                                          </Button>
                                          <Button
                                            variant={coordenada.activo ? "outline-warning" : "outline-success"}
                                            size="sm"
                                            onClick={() => cambiarEstadoCoordenada(coordenada, !coordenada.activo)}
                                          >
                                            {coordenada.activo ? <FaTimes /> : <FaCheck />}
                                          </Button>
                                        </div>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            </div>
                          )}
                        </Card.Body>
                      </Card>
                    </div>
                  )}
                </div>
              </Tab>
  
              {/* Tab 2: Gestión de sedes */}
              <Tab eventKey="sedes" title="Gestión de Sedes">
                <div className="p-3">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5>Sedes de la Empresa</h5>
                    <Button
                      variant="primary"
                      onClick={() => {
                        setSedeEmpresaActual(null);
                        setModalSedeEmpresaVisible(true);
                      }}
                    >
                      <FaPlusCircle className="me-2" />
                      Nueva Sede
                    </Button>
                  </div>
  
                  {cargandoSedes ? (
                    <div className="text-center p-4">
                      <Spinner animation="border" />
                      <p className="mt-2">Cargando sedes...</p>
                    </div>
                  ) : sedesEmpresa.length === 0 ? (
                    <Alert variant="info">
                      <FaInfoCircle className="me-2" />
                      No hay sedes configuradas para la empresa.
                    </Alert>
                  ) : (
                    <div className="table-responsive">
                      <Table striped bordered hover>
                        <thead>
                          <tr>
                            <th>Nombre</th>
                            <th>Coordenadas</th>
                            <th>Radio</th>
                            <th>Horarios</th>
                            <th>Régimen</th>
                            <th>Estado</th>
                            <th>Acciones</th>
                          </tr>
                        </thead>
                        <tbody>
                          {sedesEmpresa.map((sede) => (
                            <tr key={sede.id}>
                              <td>
                                <strong>{sede.nombre}</strong>
                              </td>
                              <td>
                                <small>
                                  Lat: {sede.latitud}<br />
                                  Lng: {sede.longitud}
                                </small>
                              </td>
                              <td>{sede.radio}m</td>
                              <td>
                                <small>
                                  {sede.horarioIngreso && sede.horarioSalida ? (
                                    <>
                                      <FaClock className="me-1" />
                                      {sede.horarioIngreso} - {sede.horarioSalida}
                                      {sede.inicioRefrigerio && sede.finRefrigerio && (
                                        <div className="text-muted">
                                          Ref: {sede.inicioRefrigerio} - {sede.finRefrigerio}
                                        </div>
                                      )}
                                    </>
                                  ) : (
                                    "Sin horarios"
                                  )}
                                </small>
                              </td>
                              <td>
                                {sede.regimenNombre ? (
                                  <small className="text-info">
                                    <FaUserClock className="me-1" />
                                    {sede.regimenNombre}
                                  </small>
                                ) : (
                                  <small className="text-muted">Sin régimen</small>
                                )}
                              </td>
                              <td>
                                <Badge bg={sede.activo ? "success" : "danger"}>
                                  {sede.activo ? "Activo" : "Inactivo"}
                                </Badge>
                              </td>
                              <td>
                                <div className="d-flex gap-1">
                                  <Button
                                    variant="outline-primary"
                                    size="sm"
                                    onClick={() => {
                                      setSedeEmpresaActual(sede);
                                      setModalSedeEmpresaVisible(true);
                                    }}
                                  >
                                    <FaEdit />
                                  </Button>
                                  <Button
                                    variant="outline-success"
                                    size="sm"
                                    onClick={() => mostrarAsignacionMasiva(sede)}
                                    title="Asignar a usuarios"
                                  >
                                    <FaUsers />
                                  </Button>
                                  <Button
                                    variant="outline-danger"
                                    size="sm"
                                    onClick={() => eliminarSedeEmpresa(sede)}
                                    title="Eliminar sede"
                                    disabled={cargandoSedeEmpresa}
                                  >
                                    <FaTrash />
                                  </Button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  )}
                </div>
              </Tab>
  
              {/* Tab 3: Usuarios asignados */}
              <Tab eventKey="usuarios-asignados" title="Usuarios Asignados">
                <div className="p-3">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5>Usuarios Asignados por Sede</h5>
                    <Button
                      variant="outline-info"
                      size="sm"
                      onClick={() => {
                        console.log("🔍 Estado actual usuariosAsignados:", usuariosAsignados);
                        console.log("🔍 Usuarios seleccionados para eliminar:", usuariosSeleccionadosParaEliminar);
                        Object.entries(usuariosAsignados).forEach(([sedeId, usuarios]) => {
                          console.log(`Sede ${sedeId}:`, usuarios.map(u => ({ 
                            dni: u.dni, 
                            nombre: u.nombre, 
                            grupo: u.grupoNombre,
                            uniqueId: u.uniqueId 
                          })));
                        });
                      }}
                    >
                      Debug Info
                    </Button>
                  </div>
                  
                  {Object.keys(usuariosAsignados).length === 0 ? (
                    <Alert variant="info">No hay usuarios asignados a ninguna sede.</Alert>
                  ) : (
                    <Accordion>
                      {Object.entries(usuariosAsignados).map(([sedeId, usuarios]) => {
                        const sede = sedesEmpresa.find(s => s.id === sedeId);
                        const usuariosSeleccionados = usuariosSeleccionadosParaEliminar[sedeId] || [];
                        const modoSeleccion = modoSeleccionMultiple[sedeId] || false;
                        const todosSeleccionados = usuarios.length > 0 && usuariosSeleccionados.length === usuarios.length;
                        
                        return (
                          <Accordion.Item key={sedeId} eventKey={sedeId}>
                            <Accordion.Header>
                              <div className="d-flex justify-content-between align-items-center w-100 me-3">
                                <span>{sede?.nombre || 'Sede sin nombre'}</span>
                                <div className="d-flex align-items-center gap-2">
                                  {modoSeleccion && usuariosSeleccionados.length > 0 && (
                                    <Badge bg="warning" pill>
                                      {usuariosSeleccionados.length} seleccionados
                                    </Badge>
                                  )}
                                  <Badge bg="primary" pill>{usuarios.length}</Badge>
                                </div>
                              </div>
                            </Accordion.Header>
                            <Accordion.Body>
                              {/* Barra de herramientas */}
                              <div className="d-flex justify-content-between align-items-center mb-3 p-2 bg-light rounded">
                                <div className="d-flex align-items-center gap-2">
                                  <Button
                                    variant={modoSeleccion ? "warning" : "outline-secondary"}
                                    size="sm"
                                    onClick={() => toggleModoSeleccionMultiple(sedeId)}
                                  >
                                    {modoSeleccion ? "Cancelar Selección" : "Selección Múltiple"}
                                  </Button>
                                  
                                  {modoSeleccion && usuarios.length > 0 && (
                                    <Button
                                      variant="outline-primary"
                                      size="sm"
                                      onClick={() => toggleSeleccionTodosUsuarios(sedeId, usuarios)}
                                    >
                                      {todosSeleccionados ? "Deseleccionar Todos" : "Seleccionar Todos"}
                                    </Button>
                                  )}
                                </div>
                                
                                {modoSeleccion && usuariosSeleccionados.length > 0 && (
                                  <Button
                                    variant="danger"
                                    size="sm"
                                    onClick={() => eliminarUsuariosSeleccionados(sedeId)}
                                    disabled={eliminandoMasivo}
                                    className="d-flex align-items-center"
                                  >
                                    {eliminandoMasivo ? (
                                      <Spinner animation="border" size="sm" className="me-2" />
                                    ) : (
                                      <FaTimes className="me-2" />
                                    )}
                                    Eliminar {usuariosSeleccionados.length} Usuario(s)
                                  </Button>
                                )}
                              </div>
  
                              <div className="table-responsive">
                                <Table size="sm" hover>
                                  <thead>
                                    <tr>
                                      {modoSeleccion && (
                                        <th style={{ width: '40px' }}>
                                          <Form.Check
                                            type="checkbox"
                                            checked={todosSeleccionados}
                                            onChange={() => toggleSeleccionTodosUsuarios(sedeId, usuarios)}
                                          />
                                        </th>
                                      )}
                                      <th>Nombre</th>
                                      <th>DNI</th>
                                      <th>Email</th>
                                      <th>Cargo</th>
                                      <th>Grupo</th>
                                      <th>Estado</th>
                                      <th>Acciones</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {usuarios.map((usuario) => {
                                      const isSelected = usuariosSeleccionados.includes(usuario.uniqueId);
                                      
                                      return (
                                        <tr 
                                          key={usuario.uniqueId || `${usuario.dni}-${usuario.coordenadaId || 'default'}`}
                                          className={modoSeleccion && isSelected ? 'table-warning' : ''}
                                        >
                                          {modoSeleccion && (
                                            <td>
                                              <Form.Check
                                                type="checkbox"
                                                checked={isSelected}
                                                onChange={() => toggleSeleccionUsuario(sedeId, usuario.uniqueId)}
                                              />
                                            </td>
                                          )}
                                          <td>{usuario.nombre}</td>
                                          <td>{usuario.dni}</td>
                                          <td>{usuario.email}</td>
                                          <td>{usuario.cargo}</td>
                                          <td>
                                            {(usuario.grupos || []).length > 0 ? (
                                              usuario.grupos.map((grupo) => (
                                                <div key={grupo}>
                                                  <small className="text-info">
                                                    <FaCogs className="me-1" />
                                                    {grupo}
                                                  </small>
                                                </div>
                                              ))
                                            ) : (
                                              <small className="text-muted">Individual</small>
                                            )}
                                          </td>
                                          <td>
                                            <Badge bg={usuario.activo ? "success" : "danger"}>
                                              {usuario.activo ? "Activo" : "Inactivo"}
                                            </Badge>
                                          </td>
                                          <td>
                                            {!modoSeleccion && (
                                              <Button
                                                variant="outline-danger"
                                                size="sm"
                                                onClick={() => removerUsuarioDeSede(sedeId, usuario)}
                                                title="Remover de sede"
                                              >
                                                <FaTimes />
                                              </Button>
                                            )}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                  </tbody>
                                </Table>
                              </div>
                              
                              {modoSeleccion && (
                                <div className="mt-2 p-2 bg-light rounded">
                                  <small className="text-muted">
                                    💡 Tip: Use "Selección Múltiple" para eliminar varios usuarios a la vez. 
                                    Útil cuando un grupo fue asignado múltiples veces por error.
                                  </small>
                                </div>
                              )}
                            </Accordion.Body>
                          </Accordion.Item>
                        );
                      })}
                    </Accordion>
                  )}
                </div>
              </Tab>
            </Tabs>
          </Card.Body>
        </Card>
  
        {/* ======================== MODALES ======================== */}
  
        {/* Modal para agregar/editar coordenada */}
        <Modal show={modalVisible} onHide={() => setModalVisible(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>
              {modoEdicion ? "Editar Coordenada" : "Nueva Coordenada"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Nombre de la Sede *</Form.Label>
                    <Form.Control
                      type="text"
                      value={nombreSede}
                      onChange={(e) => setNombreSede(e.target.value)}
                      placeholder="Ej: Sede Central Lima"
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Empresa *</Form.Label>
                    <Form.Control
                      type="text"
                      value={nombreEmpresa}
                      onChange={(e) => setNombreEmpresa(e.target.value)}
                      placeholder="Nombre de la empresa"
                    />
                  </Form.Group>
                </Col>
              </Row>
  
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Latitud *</Form.Label>
                    <Form.Control
                      type="number"
                      step="any"
                      value={latitud}
                      onChange={(e) => setLatitud(e.target.value)}
                      placeholder="-12.046373"
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Longitud *</Form.Label>
                    <Form.Control
                      type="number"
                      step="any"
                      value={longitud}
                      onChange={(e) => setLongitud(e.target.value)}
                      placeholder="-77.042755"
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Radio (metros) *</Form.Label>
                    <Form.Control
                      type="number"
                      value={radio}
                      onChange={(e) => setRadio(e.target.value)}
                      placeholder="100"
                    />
                  </Form.Group>
                </Col>
              </Row>
  
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Prioridad</Form.Label>
                    <Form.Control
                      type="number"
                      value={prioridad}
                      onChange={(e) => setPrioridad(e.target.value)}
                      min="1"
                      max="10"
                    />
                    <Form.Text className="text-muted">
                      1 = Mayor prioridad, 10 = Menor prioridad
                    </Form.Text>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Estado</Form.Label>
                    <Form.Select
                      value={activo}
                      onChange={(e) => setActivo(e.target.value === "true")}
                    >
                      <option value="true">Activo</option>
                      <option value="false">Inactivo</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
  
              {/* Sección de horarios */}
              <Form.Group className="mb-3">
                <Form.Check
                  type="checkbox"
                  label="Incluir horarios específicos"
                  checked={incluyeHorario}
                  onChange={(e) => setIncluyeHorario(e.target.checked)}
                />
              </Form.Group>
  
              {incluyeHorario && (
                <div className="border p-3 rounded mb-3">
                  <h6>Horarios de Trabajo</h6>
                  <Row>
                    <Col md={3}>
                      <Form.Group className="mb-3">
                        <Form.Label>Hora de Ingreso</Form.Label>
                        <Form.Control
                          type="time"
                          value={horarioIngreso}
                          onChange={(e) => setHorarioIngreso(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className="mb-3">
                        <Form.Label>Hora de Salida</Form.Label>
                        <Form.Control
                          type="time"
                          value={horarioSalida}
                          onChange={(e) => setHorarioSalida(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className="mb-3">
                        <Form.Label>Inicio Refrigerio</Form.Label>
                        <Form.Control
                          type="time"
                          value={inicioRefrigerio}
                          onChange={(e) => setInicioRefrigerio(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group className="mb-3">
                        <Form.Label>Fin Refrigerio</Form.Label>
                        <Form.Control
                          type="time"
                          value={finRefrigerio}
                          onChange={(e) => setFinRefrigerio(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              )}
  
              {modoEdicion && (
                <Form.Group className="mb-3">
                  <Form.Label>Motivo del Cambio *</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    value={motivoCambio}
                    onChange={(e) => setMotivoCambio(e.target.value)}
                    placeholder="Describa el motivo de este cambio para la auditoría"
                  />
                </Form.Group>
              )}
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setModalVisible(false)}>
              Cancelar
            </Button>
            <Button
              variant="primary"
              onClick={guardarCoordenada}
              disabled={cargando}
            >
              {cargando ? (
                <Spinner animation="border" size="sm" className="me-2" />
              ) : null}
              {modoEdicion ? "Actualizar" : "Guardar"}
            </Button>
          </Modal.Footer>
        </Modal>
  
        {/* Modal para gestionar sede de empresa */}
        <Modal show={modalSedeEmpresaVisible} onHide={() => setModalSedeEmpresaVisible(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>
              {sedeEmpresaActual ? "Editar Sede" : "Nueva Sede"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Nombre de la Sede *</Form.Label>
                    <Form.Control
                      type="text"
                      value={nombreSede}
                      onChange={(e) => setNombreSede(e.target.value)}
                      placeholder="Ej: Sede Central Lima"
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Estado</Form.Label>
                    <Form.Select
                      value={activo}
                      onChange={(e) => setActivo(e.target.value === "true")}
                    >
                      <option value="true">Activo</option>
                      <option value="false">Inactivo</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
  
              <Row>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Latitud *</Form.Label>
                    <Form.Control
                      type="number"
                      step="any"
                      value={latitud}
                      onChange={(e) => setLatitud(e.target.value)}
                      placeholder="-12.046373"
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Longitud *</Form.Label>
                    <Form.Control
                      type="number"
                      step="any"
                      value={longitud}
                      onChange={(e) => setLongitud(e.target.value)}
                      placeholder="-77.042755"
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>Radio (metros) *</Form.Label>
                    <Form.Control
                      type="number"
                      value={radio}
                      onChange={(e) => setRadio(e.target.value)}
                      placeholder="100"
                    />
                  </Form.Group>
                </Col>
              </Row>
  
              <div className="border p-3 rounded mb-3">
                <h6>Horarios de Trabajo</h6>
                <Row>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>Hora de Ingreso</Form.Label>
                      <Form.Control
                        type="time"
                        value={horarioIngreso}
                        onChange={(e) => setHorarioIngreso(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>Hora de Salida</Form.Label>
                      <Form.Control
                        type="time"
                        value={horarioSalida}
                        onChange={(e) => setHorarioSalida(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>Inicio Refrigerio</Form.Label>
                      <Form.Control
                        type="time"
                        value={inicioRefrigerio}
                        onChange={(e) => setInicioRefrigerio(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>Fin Refrigerio</Form.Label>
                      <Form.Control
                        type="time"
                        value={finRefrigerio}
                        onChange={(e) => setFinRefrigerio(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </div>
  
              <Form.Group className="mb-3">
                <Form.Label>Régimen de Trabajo</Form.Label>
                <Form.Select
                  value={regimenSeleccionado}
                  onChange={(e) => setRegimenSeleccionado(e.target.value)}
                >
                  <option value="">Seleccione un régimen (opcional)</option>
                  {regimenesTrabajo.map((regimen) => (
                    <option key={regimen.id} value={regimen.id}>
                      {regimen.nombre}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setModalSedeEmpresaVisible(false)}>
              Cancelar
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                const regimenSelected = regimenesTrabajo.find(r => r.id === regimenSeleccionado);
                guardarSedeEmpresa({
                  id: sedeEmpresaActual?.id,
                  nombre: nombreSede,
                  latitud: Number(latitud),
                  longitud: Number(longitud),
                  radio: Number(radio),
                  activo: activo,
                  horarioIngreso: horarioIngreso,
                  horarioSalida: horarioSalida,
                  inicioRefrigerio: inicioRefrigerio,
                  finRefrigerio: finRefrigerio,
                  regimenId: regimenSeleccionado,
                  regimenNombre: regimenSelected?.nombre || "",
                });
                setModalSedeEmpresaVisible(false);
              }}
              disabled={cargandoSedeEmpresa}
            >
              {cargandoSedeEmpresa ? (
                <Spinner animation="border" size="sm" className="me-2" />
              ) : null}
              {sedeEmpresaActual ? "Actualizar" : "Guardar"}
            </Button>
          </Modal.Footer>
        </Modal>
  
        {/* Modal para mostrar sedes disponibles */}
        <Modal show={modalSedesVisible} onHide={() => setModalSedesVisible(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Sedes Disponibles</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {cargandoSedes ? (
              <div className="text-center p-4">
                <Spinner animation="border" />
                <p className="mt-2">Cargando sedes...</p>
              </div>
            ) : sedesEmpresa.length === 0 ? (
              <Alert variant="info">No hay sedes disponibles.</Alert>
            ) : (
              <ListGroup>
                {sedesEmpresa.map((sede) => (
                  <ListGroup.Item
                    key={sede.id}
                    className="d-flex justify-content-between align-items-center"
                  >
                    <div>
                      <strong>{sede.nombre}</strong>
                      <br />
                      <small className="text-muted">
                        Radio: {sede.radio}m | Estado: {sede.activo ? "Activo" : "Inactivo"}
                      </small>
                    </div>
                    <Button
                      variant="outline-primary"
                      size="sm"
                      onClick={() => aplicarSedeATrabajador(sede)}
                      disabled={cargando}
                    >
                      {cargando ? (
                        <Spinner animation="border" size="sm" />
                      ) : (
                        "Aplicar"
                      )}
                    </Button>
                  </ListGroup.Item>
                ))}
              </ListGroup>
            )}
          </Modal.Body>
        </Modal>
  
        {/* Modal para asignación masiva */}
        <Modal show={modalAsignacionMasiva} onHide={() => setModalAsignacionMasiva(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>
              Asignar Sede: {sedeParaAsignar?.nombre}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Tabs activeKey={modoAsignacion} onSelect={setModoAsignacion}>
              <Tab eventKey="individual" title="Asignación Individual">
                <div className="mt-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Buscar Usuario</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Buscar por nombre o DNI..."
                      value={filtroUsuarios}
                      onChange={(e) => setFiltroUsuarios(e.target.value)}
                    />
                  </Form.Group>
  
                  {cargandoUsuarios ? (
                    <div className="text-center p-4">
                      <Spinner animation="border" />
                      <p className="mt-2">Cargando usuarios...</p>
                    </div>
                  ) : (
                    <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                      {usuariosDisponibles
                        .filter(usuario => 
                          usuario.nombre.toLowerCase().includes(filtroUsuarios.toLowerCase()) ||
                          usuario.dni.includes(filtroUsuarios)
                        )
                        .map((usuario) => (
                          <Form.Check
                            key={usuario.dni}
                            type="checkbox"
                            id={`user-${usuario.dni}`}
                            label={`${usuario.nombre} (${usuario.dni}) - ${usuario.cargo}`}
                            checked={usuariosSeleccionados.includes(usuario.dni)}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setUsuariosSeleccionados([...usuariosSeleccionados, usuario.dni]);
                              } else {
                                setUsuariosSeleccionados(usuariosSeleccionados.filter(dni => dni !== usuario.dni));
                              }
                            }}
                            className="mb-2"
                          />
                        ))}
                    </div>
                  )}
  
                  <div className="mt-3">
                    <small className="text-muted">
                      {usuariosSeleccionados.length} usuario(s) seleccionado(s)
                    </small>
                  </div>
                </div>
              </Tab>
  
              <Tab eventKey="grupos" title="Asignación por Grupos">
                <div className="mt-3">
                  <Form.Group className="mb-3">
                    <Form.Label>Buscar Grupo</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Buscar por nombre de grupo..."
                      value={filtroGrupos}
                      onChange={(e) => setFiltroGrupos(e.target.value)}
                    />
                  </Form.Group>
  
                  {cargandoGrupos ? (
                    <div className="text-center p-4">
                      <Spinner animation="border" />
                      <p className="mt-2">Cargando grupos...</p>
                    </div>
                  ) : (
                    <div style={{ maxHeight: '400px', overflowY: 'auto' }}>
                      {gruposEmpresa
                        .filter(grupo => 
                          grupo.name.toLowerCase().includes(filtroGrupos.toLowerCase())
                        )
                        .map((grupo) => (
                          <Form.Check
                            key={grupo.id}
                            type="checkbox"
                            id={`group-${grupo.id}`}
                            label={`${grupo.name} (${grupo.members.length} miembros)`}
                            checked={gruposSeleccionados.includes(grupo.id)}
                            onChange={(e) => {
                              if (e.target.checked) {
                                setGruposSeleccionados([...gruposSeleccionados, grupo.id]);
                              } else {
                                setGruposSeleccionados(gruposSeleccionados.filter(id => id !== grupo.id));
                              }
                            }}
                            className="mb-2"
                          />
                        ))}
                    </div>
                  )}
  
                  <div className="mt-3">
                    <small className="text-muted">
                      {gruposSeleccionados.length} grupo(s) seleccionado(s)
                    </small>
                  </div>
                </div>
              </Tab>
            </Tabs>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setModalAsignacionMasiva(false)}>
              Cancelar
            </Button>
            <Button
              variant="primary"
              onClick={modoAsignacion === "individual" ? asignarSedeAUsuarios : asignarSedeAGrupos}
              disabled={
                (modoAsignacion === "individual" && usuariosSeleccionados.length === 0) ||
                (modoAsignacion === "grupos" && gruposSeleccionados.length === 0) ||
                asignandoMasivo || asignandoGrupos
              }
            >
              {(asignandoMasivo || asignandoGrupos) ? (
                <Spinner animation="border" size="sm" className="me-2" />
              ) : null}
              {modoAsignacion === "individual" 
                ? `Asignar a ${usuariosSeleccionados.length} Usuario(s)` 
                : `Asignar a ${gruposSeleccionados.length} Grupo(s)`}
            </Button>
          </Modal.Footer>
        </Modal>
  
        {/* Modal para mostrar historial */}
        <Modal show={historialVisible} onHide={() => setHistorialVisible(false)} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>Historial de Cambios</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {historialCoordenada.length === 0 ? (
              <Alert variant="info">No hay historial disponible para esta coordenada.</Alert>
            ) : (
              <div className="table-responsive">
                <Table striped bordered hover size="sm">
                  <thead>
                    <tr>
                      <th>Fecha</th>
                      <th>Operación</th>
                      <th>Usuario</th>
                      <th>Cambios</th>
                      <th>Motivo</th>
                    </tr>
                  </thead>
                  <tbody>
                    {historialCoordenada.map((historial) => (
                      <tr key={historial.id}>
                        <td>{formatearFecha(historial.timestamp)}</td>
                        <td>
                          <Badge 
                            bg={
                              historial.tipo_operacion === "creación" ? "success" :
                              historial.tipo_operacion === "actualización" ? "primary" :
                              historial.tipo_operacion === "cambio de estado" ? "warning" :
                              "secondary"
                            }
                          >
                            {historial.tipo_operacion}
                          </Badge>
                        </td>
                        <td>{historial.admin_nombre}</td>
                        <td>{renderizarCambios(historial.cambios)}</td>
                        <td>{historial.motivo}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            )}
          </Modal.Body>
        </Modal>
  
        {/* Modal de confirmación personalizado */}
        <Modal show={modalConfirmacion} onHide={cancelarAccion} centered>
          <Modal.Header closeButton>
            <Modal.Title>Confirmar Acción</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{mensajeConfirmacion}</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={cancelarAccion}>
              Cancelar
            </Button>
            <Button variant="primary" onClick={confirmarAccion}>
              Confirmar
            </Button>
          </Modal.Footer>
        </Modal>
  
        {/* Modal de prompt personalizado */}
        <Modal show={modalPrompt} onHide={cancelarPrompt} centered>
          <Modal.Header closeButton>
            <Modal.Title>Ingrese Información</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>{mensajePrompt}</p>
            <Form.Control
              type="text"
              value={valorPrompt}
              onChange={(e) => setValorPrompt(e.target.value)}
              placeholder="Ingrese su respuesta..."
              autoFocus
            />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={cancelarPrompt}>
              Cancelar
            </Button>
            <Button variant="primary" onClick={confirmarPrompt}>
              Confirmar
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    );
  };
  
  export default AsistenciaCoordenadas;
